import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import React from 'react';
import { ListItem } from './list-item';
export const SearchListItem = React.forwardRef((props, ref) => {
    const { palette } = useTheme();
    const { selected, children, variant = 'item', forwardedRef, ...restProps } = props;
    const itemRef = React.useRef(null);
    const headerSx = {
        color: variant === 'header'
            ? palette.text.disabled
            : palette.text.primary,
        height: 35,
        px: 2,
        py: 1
    };
    const listItemTextProps = {
        primary: {
            sx: {
                fontWeight: variant === 'header' ? 'bold' : 'normal',
                textTransform: variant === 'header' ? 'uppercase' : 'capitalize'
            }
        }
    };
    return (_jsx(ListItem, { ref: ref || forwardedRef || itemRef, ...restProps, selected: selected, sx: headerSx, textSlotProps: listItemTextProps, children: children }));
});
